
export enum EnumValidatorType {
  Value,
  Length
}

export interface IValidationPatten {
  value: RegExp;
  message: string;
}

export interface IValidation {
  required: boolean;
  message?: string;
  patterns?: IValidationPatten[];
  where?: {
    fieldParent: string,
    value: any,
    required: boolean,
    message?: string;
    patterns?: IValidationPatten[];
    validationType: EnumValidatorType;
  }
}

export interface IValidatorField {
  field: string;
  validations: IValidation;
}
